module.exports = __webpack_public_path__ + "media/icons/mailing-twitter@3x-62063e26.svg";